import { Badge, Col, Input, Progress, Row, Skeleton } from "antd";
import React, { FC, useEffect, useState } from "react";
import { RightCircleOutlined } from "@ant-design/icons";
import "./subjectsAnalyticsCards.scss";
import ScoreIcon from "../../../../../../../assets/icons/reward.svg";
import AccuracyIcon from "../../../../../../../assets/icons/dart.svg";
import SpeedIcon from "../../../../../../../assets/icons/sketch.svg";
import DurationIcon from "../../../../../../../assets/icons/sand-clock.svg";
import {
  SearchOutlined,
  RightOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import AnalyticsComponent from "../AnalyticsComponent";
import Search from "antd/lib/input/Search";
import { AnalyticsEmptyScreen } from "../EmptyScreen";
//container
import AnalyticsContainer from "../../../../../store/container/AnalyticsContainer";

//model
import { StudentClassResult } from "../../../../../models/Analytics/class.model";
import {
  StudentSubjectResult,
  ClassRoomSubjectModel,
  SubjectModel
} from "../../../../../models/Analytics/subject.model";



interface SubjectsProps {
  onClick: (id: any, name: any) => void;
  courseAnalytics: StudentClassResult;
  type: any;
  loading: boolean
}
const SubjectsAnalyticsCard: FC<SubjectsProps> = ({
  onClick,
  type = "class_room",
  courseAnalytics,
  loading = true
}) => {

  const [subjects, setSubjects] = useState<SubjectModel[]>([]);
  const [selectedSubject, setSelectedSubject] = useState<any>();
  const [studentSubjectResult, setStudentSubjectResult] = useState<StudentSubjectResult>();
  const [showSearch, setSearchVisibility] = useState(false);

  const fetchSubjects = (params: any) => {
    if (type == "class_room" && courseAnalytics?.studentSubjects?.length) {
      let subjectList = courseAnalytics?.studentSubjects

      if (params?.search?.toUpperCase() !== undefined)
        subjectList = subjectList.filter(element => element.name?.toUpperCase()?.includes(params?.search?.toUpperCase()))

      setSubjects(subjectList);
      if (subjectList.length) {
        setSelectedSubject(subjectList[0]);
        fetchSubjectAnalytics(subjectList[0].id);
      }

    }
  };

  const fetchSubjectAnalytics = (subjectId: any) => {
    if (type == "exam") {
      // AnalyticsService.fetchExamSubjectAnalytics(
      //   currentCourse?.id,
      //   subjectId,
      //   (result) => {
      //     setStudentSubjectResult(result);
      //   },
      //   () => {}
      // )
    }
    else if (type == "class_room") {
      setStudentSubjectResult(courseAnalytics?.studentSubjects?.find(element => element.subjectId == subjectId));
    }
  };

  useEffect(() => {
    fetchSubjects({});
  }, [courseAnalytics?.studentSubjects]);

  if (loading) {
    return (
      <Row className="list__subjects" style={{ padding: 15 }}>
        <Skeleton active />
        <Skeleton active />
      </Row>
    )
  }

  return (
    <Row className="list__subjects">
      {subjects.length == 0 ? (
        <AnalyticsEmptyScreen title={"No subjects"} />
      ) : (
        <>
          <Col span={12} style={{ height: "100%" }}>
            <div className="content__left">
              {showSearch ? (
                <div className="content-left__search">
                  <Input
                    className="content-left-search__input"
                    placeholder={"Search"}
                    prefix={<SearchOutlined />}
                    onChange={(e) => {
                      fetchSubjects({ search: e.target.value });
                    }}
                  />
                  <CloseOutlined
                    className="content-left-search__icon"
                    onClick={() => setSearchVisibility(false)}
                  />
                </div>
              ) : (
                <div className="content-left__header">
                  <p>Subjects</p>
                  <div onClick={() => setSearchVisibility(true)}>
                    <SearchOutlined />
                  </div>
                </div>
              )}

              {subjects?.map((value, index) => {
                return (
                  <div
                    className={`analytics-subject__card ${selectedSubject?.id == value.id && "subject-card__active"
                      }`}
                    onClick={() => {
                      setSelectedSubject(value);
                      fetchSubjectAnalytics(value?.id);
                    }}
                  >
                    <p className="subject-card__name">{value?.name}</p>
                    <div className="subjects-details__container">
                      <p>{value?.chapterCount} Chapters</p>
                      <Badge status="default" className="dull-text" />
                      <div className="progress__wrapper">
                      <Progress showInfo={false} />
                        <p>
                          {(value?.cummulativeCompletionPercentage !==
                            undefined &&
                            value?.cummulativeCompletionPercentage !== null &&
                            value?.cummulativeCompletionPercentage > 0 &&
                            Math.ceil(
                              value?.cummulativeCompletionPercentage
                            )) ||
                            0}
                          % Completed
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col span={12} style={{ height: "100%" }}>
            <div className="content__right">
              <div className="content-right__header">
                <p>{selectedSubject?.name}</p>
                <div
                  className="content-right__btn"
                  onClick={() =>
                    onClick(selectedSubject?.id, selectedSubject?.name)
                  }
                >
                  View by chapter{" "}
                  <span>
                    <RightOutlined />
                  </span>
                </div>
              </div>
              <AnalyticsComponent
                showAttempts={false}
                accuracy={studentSubjectResult?.accuracy}
                contentLearnt={studentSubjectResult?.completedContentCount || 0}
                totalContent={studentSubjectResult?.totalContentCount || 0}
                exerciseAttempted={
                  studentSubjectResult?.numberOfExerciseAttempts || 0
                }
                noOfExerciseAttempted={
                  studentSubjectResult?.numberOfExerciseAttempts || 0
                }
                totalExercise={studentSubjectResult?.totalExerciseCount || 0}
                speed={studentSubjectResult?.averageTimePerQuestion}
                score={studentSubjectResult?.score}
                duration={studentSubjectResult?.exerciseAttemptDuration}
              />
            </div>
          </Col>
        </>
      )}
    </Row>
  );
};
export default AnalyticsContainer(SubjectsAnalyticsCard);
